let eSignAppPortalUrl = 'https://dmsworkspace-esignature-frontend-int.dmsworkspace.com/';
export const environment = {
  production: false,
  apiKey: 'CEqSRxQnIvwg6o5gJ54KGJdZ02Tbmhem',
  eSignAppPortalUrl: eSignAppPortalUrl,
  eSignAppSsoUrl: `https://dmsworkspace-sso-pre.dmsworkspace.com/realms/dmsworkspace/protocol/openid-connect/registrations?client_id=dmsworkspace-esignature-frontend&response_type=code&scope=openid&redirect_uri=${eSignAppPortalUrl}&code_challenge=U4p8FvrUiRcyvCYDk17RVk_5Pdii-1QZ1y8yhQloh70&code_challenge_method=S256`,
};
